import fetchWithAuth from "@/api/secureFetch";
import type { RoomParts } from "./roomName";

export interface ResolveCollabRoomRequest {
    productId: number;
    workProductId: number;
    featureId?: number;
    userStoryId?: string;
}

export async function resolveCollabRoom(
    request: ResolveCollabRoomRequest,
    token: string,
    signal?: AbortSignal
): Promise<RoomParts> {
    const response = await fetchWithAuth("/api/collab/room/resolve", token, {
        method: "POST",
        headers: { Accept: "application/json", "Content-Type": "application/json" },
        body: JSON.stringify(request),
        signal
    });
    if (!response.ok) throw new Error(`Collaboration room resolution failed (${response.status})`);
    const payload = await response.json() as { room?: Record<string, unknown>; requestId?: unknown };
    const room = payload.room;
    const expectedFeatureId = request.featureId ?? null;
    const expectedUserStoryId = request.userStoryId ?? null;
    if (
        !room || room.productId !== request.productId || room.workProductId !== request.workProductId ||
        typeof room.version !== "number" || !Number.isSafeInteger(room.version) || room.version <= 0 ||
        room.featureId !== expectedFeatureId || room.userStoryId !== expectedUserStoryId ||
        typeof payload.requestId !== "string" || !payload.requestId
    ) throw new Error("Collaboration room response is invalid");
    return {
        projectId: request.productId,
        workProductId: request.workProductId,
        featureId: room.featureId as number | null,
        userStoryId: room.userStoryId as string | null,
        version: room.version
    };
}
